import { Component, OnDestroy } from '@angular/core';
import { FuseConfigService } from '../../../../core/services/config.service';
import { ServerService } from '../../../../core/services/server.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'server-on-service',
    templateUrl: './server-info.component.html',
    styleUrls: ['./server-info.component.scss'],
    standalone: false
})

export class ServerInfoComponent implements OnDestroy {
  months = ['january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ];
  monthIndex = 0;
  private subscriptions =  new Subscription();
  constructor(private fuseConfig: FuseConfigService,
              private serverService: ServerService,
              private router: Router) {
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none' ,
        toolbar: 'none' ,
        footer: 'none'
      }
    });
    this.monthIndex = new Date().getMonth();
    this.subscriptions.add(this.serverService.updateServer.subscribe((res: any) => {
      if (res) {
        this.router.navigate(['/pages/auth/login']);
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
